// extracted by mini-css-extract-plugin
export default {"title":"notecard-mobile-message__title___CJ0TR","subTitle":"notecard-mobile-message__subTitle___DS4NZ","buttonContainer":"notecard-mobile-message__buttonContainer___x917S"};